import { SCREEN_VIEW } from '@/constants/analytics';
import useBlogPageContent from '@/hooks/blog/useBlogPage';
import useMobileView from '@/hooks/useMobileView';
import useTrackScreenShown from '@/hooks/useTrackScreenShown';
import { _s } from '@/locale';
import { TriggerSource } from '@/types/analytics';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import Modal from '../../modals/redesign/Modal/Modal';
import css from './CheckoutTerms.module.scss';

const baseTranslationKey = 'components.modules.checkout.ConfirmationCta';

const CheckoutTerms = ({
  className = '',
  triggerSource,
  termsPageId,
  description,
  linkLabel,
  floating = false,
  onClose,
}: {
  className?: string;
  triggerSource: TriggerSource;
  termsPageId: number;
  description: string;
  linkLabel: string;
  floating?: boolean;
  onClose: () => void;
}) => {
  const [showTerms, setShowTerms] = useState(false);
  const { isMobileView, windowSize } = useMobileView();

  useTrackScreenShown(
    { screen_name: SCREEN_VIEW.GENERAL_TERMS, initiated_from: triggerSource },
    [showTerms],
    [showTerms],
  );

  return (
    <div className={twMerge('text-s text-center', className)}>
      <span
        className="text-fg_secondary text-inherit"
        {...(floating && windowSize.width < 500 && { style: { fontSize: 10, lineHeight: '12px' } })}>
        {description}{' '}
        <button
          type="button"
          onClick={() => setShowTerms(true)}
          className="text-fg_link inline text-left text-inherit underline">
          {linkLabel}
        </button>
      </span>
      {showTerms && (
        <Modal isOpen>
          <Modal.Content floating={!isMobileView}>
            <Modal.Header
              title={_s(`${baseTranslationKey}.modal.title`)}
              onClose={() => {
                setShowTerms(false);
                onClose();
              }}
            />
            <Terms pageId={termsPageId} />
          </Modal.Content>
        </Modal>
      )}
    </div>
  );
};

const Terms = ({ pageId }: { pageId: number }) => {
  const content = useBlogPageContent(pageId);
  return <div className={`${css.generalTermsContent}`} dangerouslySetInnerHTML={{ __html: content }}></div>;
};

export default CheckoutTerms;
